import { IncentiveOffer, IncentiveOfferType } from 'modules/incentivesMarket/types';
import { IncentivesMarketPlanContext } from 'modules/incentivesMarket/types/IncentivesMarketBeneficiaryContext';

import { distributeSellUnitsByPlan } from 'modules/incentivesMarket/pages/IncentiveOfferDetail/utils/distributeSellUnitsByPlan';
import { buildSellBreakdownFromSelection } from 'modules/incentivesMarket/pages/IncentiveOfferDetail/utils/buildSellBreakdownFromSelection';
import { mapSellerPlansToSellPlans } from 'modules/incentivesMarket/pages/IncentiveOfferDetail/utils/mapSellerPlansToSellPlans';

type GetIncentiveOfferAcceptTotalPriceArgs = {
  offer: Pick<IncentiveOffer, 'type' | 'unitPrice'>;
  purchaseQuantity: number;
  sellerPlans?: IncentivesMarketPlanContext[];
  sellPlanSelection?: Record<string, number> | null;
  retentionPercent?: number;
};

export const getIncentiveOfferAcceptTotalPrice = ({
  offer,
  purchaseQuantity,
  sellerPlans = [],
  sellPlanSelection = null,
  retentionPercent = 0,
}: GetIncentiveOfferAcceptTotalPriceArgs): number => {
  const isSellOffer = offer.type === IncentiveOfferType.SELL;

  if (!isSellOffer && sellerPlans.length > 0 && sellPlanSelection) {
    const { total } = buildSellBreakdownFromSelection({
      plans: mapSellerPlansToSellPlans({ offer, sellerPlans }),
      sellerPlans,
      unitsByPlan: sellPlanSelection,
      retentionPercent,
    });

    return total;
  }

  if (!isSellOffer && sellerPlans.length > 0) {
    const { total } = distributeSellUnitsByPlan({
      plans: sellerPlans,
      totalUnits: purchaseQuantity,
      sellingPrice: offer.unitPrice,
      retentionPercent,
    });

    return total;
  }

  return purchaseQuantity * offer.unitPrice;
};
